module.exports = __webpack_public_path__ + "static/media/logoBOD.e778532d.png";